import { ActionIcon } from "PFComponents/action_icon";
import { Button } from "PFComponents/button";
import React from "react";
import { useTranslation } from "react-i18next";

import css from "./actions.module.scss";

interface IAddButtonProps {
  disabled: boolean;
  setAddNewInSection: (arg: any) => void;
  kind: string;
}

export const AddButton = ({ disabled, setAddNewInSection, kind }: IAddButtonProps) => {
  const { t } = useTranslation();
  return (
    <Button
      icon="add"
      text={t("add")}
      kind="primary"
      onClick={() => setAddNewInSection({ min: null, max: null, color: "#aaa", kind: kind, new: true })}
      className={css.addButton}
      disabled={disabled}
    />
  );
};

interface IEditButtonProps {
  setEditMode: (boolean) => void;
}

export const EditButton = ({ setEditMode }: IEditButtonProps) => (
  <ActionIcon name="edit" size="md" onClick={setEditMode} />
);

interface ISubmitCancelProps {
  cancelEdit: () => void;
  submitEdit: () => void;
}

export const SubmitCancelButtons = ({ cancelEdit, submitEdit }: ISubmitCancelProps) => {
  const { t } = useTranslation();
  return (
    <div className={css.submitCancelButtons}>
      <Button onClick={() => submitEdit()} small>
        {t("save")}
      </Button>
      <Button kind="danger" onClick={() => cancelEdit()} small>
        {t("cancel")}
      </Button>
    </div>
  );
};

interface IRemoveItemProps {
  removeItem(key: string): void;
  keyToRemove: string;
}

export const RemoveItem = ({ removeItem, keyToRemove }: IRemoveItemProps) => (
  <ActionIcon name="remove" size="md" onClick={() => removeItem(keyToRemove)} />
);
